import { makeObservable, observable, action } from 'mobx';

class LoadingProgressStore {
  isLoading = false;

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      toggleIsLoading: action,
    });
  }

  toggleIsLoading(toggle) {
    this.isLoading = toggle;
  }
}

export default new LoadingProgressStore();
// export const AuthStoreContext = createContext(new AuthStore());
